import { OrderType } from 'models/order.model';
import React, { FC, useState } from 'react';
import { ReactComponent as AvatarIcon } from 'assets/icons/avatar.svg';
import { CalendarIcon, NoteIcon } from 'cokitchen-icons';
import moment from 'moment';
import PushNotificationModal from 'components/live-trip-cards/live-trip-modals/push-notification';
import UserProfileSideModal from 'pages/search/user-profile-side-modal';
import CSUserProfileSideModal from 'components/cs/modals/user-profile-modal';
import { getNameFromOrder, isCSRole } from 'utils/functions';

type Props = {
  order: OrderType;
};
const OrderDetailsUser: FC<Props> = ({ order }) => {
  const [pushNotification, setPushNotification] = useState(false);
  const [showUserProfile, setShowUserProfile] = useState(false);

  const pushNotifications = () => {
    setPushNotification(!pushNotification);
  };

  return (
    <>
      <div className='px-6 pt-4 pb-5 bg-[#F7F7F8] min-h-[88px] flex justify-between items-center flex-wrap gap-4'>
        <div className='flex gap-4'>
          <AvatarIcon className='w-8 h-8' />
          <div className='cursor-pointer' onClick={() => setShowUserProfile(true)}>
            <p className='text-[#595959] font-medium mb-2'>{getNameFromOrder(order)}</p>
            <div className='flex gap-2 flex-wrap text-xs text-[#595959] items-center'>
              <CalendarIcon className='w-4 h-4' />
              <p className='text-[#595959] text-xs'>
                Date registered:
                {moment(order.user.created_at.split('T')[0]).format('Do MMM, YYYY')}
              </p>
              <div className='bg-[#DCDBD5] w-[5px] h-[5px] rounded-full' />
              <p className='text-[#595959] text-xs'>{order.user.email}</p>
              <div className='bg-[#DCDBD5] w-[5px] h-[5px] rounded-full' />
              <p className='text-[#595959] text-xs'>{order.user.phone_number}</p>
            </div>
          </div>
        </div>
        <div
          role='button'
          className='bg-gray-6 rounded-[40px] px-4 py-[6px] flex gap-1  text-white text-xs cursor-pointer'
          onClick={pushNotifications}>
          <NoteIcon className='w-4 h-4' />
          Notify user
        </div>
      </div>
      <PushNotificationModal order={order} show={pushNotification} onClose={pushNotifications} />
      {isCSRole() ? (
        <CSUserProfileSideModal
          show={showUserProfile}
          closeModal={() => setShowUserProfile(false)}
          id={order?.user?.id}
        />
      ) : (
        <UserProfileSideModal
          show={showUserProfile}
          closeModal={() => setShowUserProfile(false)}
          user={order.user}
        />
      )}
    </>
  );
};

export default OrderDetailsUser;
